import { CurrentCycleContent } from '../../model/dto/current-cycle-content';
import { OvTableData } from '../../../components/UI/molecules/OvTable';
import { TableRowEditWidgetType } from '../../model/ui/table-row-edit-widget.type';
import i18n from '../../../i18n/config';
import DateUtils from './date-utils';

export class CurrentCycleContentDataUtils {
  static mapCurrentCycleContentToTableData(
    currentCycleContent?: CurrentCycleContent
  ): OvTableData {
    return [
      {
        label: 'currentCycleContents.fields.minAge',
        value: currentCycleContent?.min_age,
        translateLabel: true,
      },
      {
        label: 'currentCycleContents.fields.maxAge',
        value: currentCycleContent?.max_age,
        translateLabel: true,
      },
      {
        label: 'currentCycleContents.fields.healthGoal',
        value: currentCycleContent?.health_goal,
        translateLabel: true,
      },
      {
        label: 'currentCycleContents.fields.currentPhase',
        value: currentCycleContent?.current_phase,
        translateLabel: true,
      },
      {
        label: 'currentCycleContents.fields.currentPhaseDescription',
        value: currentCycleContent?.current_phase_description,
        translateLabel: true,
        editOptions: {
          widgetType: TableRowEditWidgetType.TEXT_AREA,
          propertyName: 'current_phase_description',
          placeholder: i18n.t(
            'currentCycleContents.fields.currentPhaseDescription'
          ),
        },
      },
      {
        label: 'common.createdAt',
        value: currentCycleContent?.created_at,
        translateLabel: true,
        prettifiedValue: DateUtils.formatDate(
          currentCycleContent?.created_at as Date,
          'MMMM DD, YYYY, HH:mm:ss'
        ),
      },
      {
        label: 'common.updatedAt',
        value: currentCycleContent?.updated_at,
        translateLabel: true,
        prettifiedValue: DateUtils.formatDate(
          currentCycleContent?.updated_at as Date,
          'MMMM DD, YYYY, HH:mm:ss'
        ),
      },
    ];
  }

  static getAgeRange(currentCycleContent?: CurrentCycleContent): string {
    if (currentCycleContent?.min_age && currentCycleContent?.max_age) {
      return `${currentCycleContent?.min_age}-${currentCycleContent?.max_age}`;
    }

    if (currentCycleContent?.min_age) {
      return `${currentCycleContent?.min_age}+`;
    }

    if (currentCycleContent?.max_age) {
      return `<${currentCycleContent?.max_age + 1}`;
    }

    return '-';
  }
}
